module.exports = __webpack_public_path__ + "static/assets/875ddabe4a1522dae02bc2cc2486434e.svg";